/**
 * @license
 *
 * Copyright IBM Corp. 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Pictogram colors.
 */
export enum COLOR_OPTIONS {
  /**
   * Defaults to component text color.
   */
  DEFAULT = '',

  /**
   * Blue - $link-01
   */
  BLUE = 'blue',
}
